import ScheduleCalculator from './ScheduleCalculator'

function CorporateScheduleCalculator()
{
    this.constructor= CorporateScheduleCalculator;
}

CorporateScheduleCalculator.prototype = new ScheduleCalculator();

CorporateScheduleCalculator.prototype.init = function ( invertedDaysMap,  corporateSchedule )
{
    const schedules = [];

    schedules.push(   { durations:corporateSchedule }   );

    ScheduleCalculator.prototype.init.call(this, invertedDaysMap, schedules);

    return this;
};

export default CorporateScheduleCalculator



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/CorporateScheduleCalculator.js